import React from 'react'

export interface IWorkspaceActionBarContext {
    currentState: Record<string, any>
    setStateValue: (stateKey: string, newValue: any, persist?: boolean) => any
}

export const WorkspaceActionBarContext = React.createContext(
    {} as IWorkspaceActionBarContext
)

export interface WorkspaceActionBarProviderProps {
    stateObject: Record<string, any>
    setState: (stateKey: string, newValue: any, persist?: boolean) => any
}
export const WorkspaceActionBarProvider: React.FC<WorkspaceActionBarProviderProps> = ({
    stateObject = {},
    setState,
    children,
}) => {
    const state = React.useMemo(() => stateObject, [stateObject])
    const context: IWorkspaceActionBarContext = {
        currentState: state,
        setStateValue: setState,
    }
    return (
        <WorkspaceActionBarContext.Provider value={context}>
            {children}
        </WorkspaceActionBarContext.Provider>
    )
}
